import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import moment from 'moment';
import { PageHeader, Menu, Dropdown, Button, Tag, Card, Row, Col } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import {getSubjects} from '../actions/subject';
import {getLessonplans} from '../actions/lessonplan';
import {getCbts} from '../actions/cbt';
import SubjectCard from "./SubjectCard";
import LessonPlanCard from './LessonPlanCard';
import TestCards from './TestCards';
import { useNavigate } from 'react-router-dom';

const Subjects = (props) => {
    const [sessions, setsessions] = useState({})
    const [subjects, setsubjects] = useState({})
    const [page, setpage] = useState(0)


    let nav = useNavigate()
    const get_rows = (id, arrays) =>{
        if(arrays !== null 
            && arrays!== undefined 
            && arrays.hasOwnProperty(id)){
            return arrays[id]
        }
        return []
   }

    useEffect(() => {
      if(typeof sessions === 'object' && Object.keys(sessions).length == 0){
      let active_session = {}
      let term_to_array =  Object.keys(props.reports.terms).map((p, i)=>{
          return props.reports.terms[p]
        })
      console.log(term_to_array)
      term_to_array.forEach(p=>{
          if(p.is_active === "0"){
            active_session = p
          }
      })
      setsessions(active_session)
      }
    }, [])  
   
   useEffect(() => {
    let session = sessions.sessionid
    let term = sessions.id
    let params = {
    data:JSON.stringify(
    {
          'sessionid':session,
          'termid':term,
          'studentid' : props.mid
      }),
      cat:'selected_subject',
      table:'studentscore',
      narration:'get subjects'
    }
    props.getSubjects(params)

   }, [sessions, props.mid])
   
   let arr_reports = []
   Object.keys(props.reports.reports).forEach(schoolid=>{
        let sessions = props.reports.reports[schoolid]
        Object.keys(sessions).forEach(sessionid=>{
            let arr = {}
            let sch = get_rows(schoolid, props.schools)
            let ses = get_rows(sessionid, props.sessions)
            arr['schoolname'] = sch.abbrv || ''
            arr['sessionname'] = ses.name || ''
            arr['schooldata'] = sch
            arr['sessiondata'] = ses
            arr_reports.push(arr)              
        })
    })
    const loadResult = (d) =>{
        setsessions(d)
        setpage(0)
        let session = d.sessionid
            let params = {
            data:JSON.stringify(
            {
                  'sessionid':session,
                  'studentid' : props.mid
              }),
              cat:'selected_subject',
              table:'assets',
              narration:'get subjects'
            }
            props.getSubjects(params)
    }
    const loadPlans = (d) =>{
      setsubjects(d)
      //setpage(1)
      let session = sessions.sessionid
      let term = sessions.id
          // let params = {
          // data:JSON.stringify(
          // {
          //       'sessionid':session,
          //       'termid':term,
          //       'staffid':d.itemid1,
          //       'subjectid':d.itemid,
          //       'claszid':d.contact,
          //       'studentid' : props.mid
          //   }),
          //   cat:'selected_lessonplan',
          //   table:'assets',
          //   narration:'get subjects'
          // }
          // props.getLessonplans(params)
          
          nav(`subject/${d.itemid}`, 
          {state : {
            'subjectname':d.itemname,
            'termname':sessions.name,
            'sessionid':session,
            'termid':term,
            'staffid':d.itemid1,
            'subjectid':d.itemid,
            'claszid':d.contact,
            'studentid' : props.mid
          }}
          )
    }
    const loadTest = (d) =>{
      setsubjects(d)
      setpage(2)
      let session = sessions.sessionid
      let term = sessions.termid
          let params = {
            data:JSON.stringify(
            {
                  'sessionid':session,
                  'termid':term,
                  'staffid':d.staffid,
                  'subjectid':d.itemid,
                  'claszid':d.contact,
                  'studentid' : props.mid
              }),
              cat:'selected_cbt',
              table:'assets',
              narration:'get cbts'
            }
          props.getCbts(params)
    }
    const menu = (
        <Menu>
            {
             typeof props.reports.terms  === 'object' ?
                Object.keys(props.reports.terms).map((p, index)=>{
                  let prop = props.reports.terms[p]
                    return <Menu.Item 
                        key={index} 
                        onClick={()=>loadResult(prop)}
                    >
                      {`${prop.name}`}
                  </Menu.Item>
                }):''
            }
        </Menu>
      );

    const DropdownMenu = () => (
        <Dropdown key="more" overlay={menu}>
          <Button>
            <EllipsisOutlined
              style={{
                fontSize: 20,
                verticalAlign: 'top',
              }} 
            /> Select Term
          </Button>
        </Dropdown>
    );

  return (
    <div>
            <PageHeader
                title="My Subjects"
                className="site-page-header no-print"
                subTitle={sessions.name || '-'}
                tags={sessions.is_active == 1 ? <Tag color="blue">Current</Tag>:<Tag color="red">Inactive</Tag>}
                extra={[
                    <DropdownMenu key="more" />,
                ]}
                avatar={{ src: process.env.PUBLIC_URL+'/asset/icons/fee.png' }}    
            ></PageHeader>


            {page !== 1 && page !== 2 ?
            <>
            <Card>
                <h2 className="text-left">{`${sessions.name || 'Select'} Session`}</h2>
                <h5 className="text-left">{`${moment(sessions.started).format('Do MMM YYYY')} to ${moment(sessions.ended).format('Do MMM YYYY')} `}</h5>
            </Card>
            <Row> 
              {
                Array.isArray(props.subjects) ?
                props.subjects.map((prop, ind)=>{
                  return <SubjectCard
                    key={ind}
                    data={prop}
                    loadPlans={(e)=>loadPlans(e)}
                    loadTest={(e)=>loadTest(e)}
                  />
                }): null
              }  
            </Row></>:""}
            {page === 1?
            <><Card>
                <h2 className="text-left">{`${subjects.itemname || ''}`}  <small>{`${sessions.name || ''} Session`}</small></h2>
                <h5 className="text-left">{`${moment(sessions.started).format('Do MMM YYYY')} to ${moment(sessions.ended).format('Do MMM YYYY')} `}</h5>
            
            </Card><Row className="text-left"> 
              { typeof props.lessonplans == 'object'?
                  <LessonPlanCard
                    data={props.lessonplans}
                  />:''
              }  
            </Row></>:""}
            {page === 2?
            <>
            <Card>
            <h2 className="text-left">{`${subjects.itemname || ''}`}  <small>{`${sessions.name || ''} Session`}</small></h2>
                <h5 className="text-left">{`${moment(sessions.started).format('Do MMM YYYY')} to ${moment(sessions.ended).format('Do MMM YYYY')} `}</h5>
            </Card>
            <Row> 
              {typeof props.cbts == 'object'? 
              <TestCards 
                data={props.cbts}
                sid={props.schoolid}
                mid={props.mid}
              />:''}  
            </Row>
            </>
            :""}

            
        </div>
  )
}

const mapStateToProps = (state) => ({
    reports:state.reportReducer,
    subjects:state.subjectReducer.subjects,
    lessonplans:state.lessonplanReducer.lessonplans,
    cbts:state.cbtReducer.cbts,
    mid:state.userReducer.mid,
    schoolid:state.userReducer.schoolid,
})

const mapDispatchToProps = {getSubjects, getLessonplans, getCbts}

export default connect(mapStateToProps, mapDispatchToProps)(Subjects)